import { createApp } from "vue";
import VueApexCharts from "vue3-apexcharts";
import "./assets/tailwind.css";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import Toast, { POSITION, type PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { createPinia } from 'pinia'
import socket from "./modules/pedidos/services/socketPedido.service";
import { useNotificationStore } from "./stores/notificationStore";

const app = createApp(App);
const pinia = createPinia();
// Pinia debe estar activo antes de registrar handlers que usan stores.
app.use(pinia);

const options: PluginOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
};

socket.on("notificacionPedido", (notif: Record<string, unknown>) => {
  try {
    const store = useNotificationStore();
    store.addNotification({
      idPedido: (notif.idPedido as string | number) ?? "",
      cliente: String(notif.cliente ?? "Cliente"),
      estado: String(notif.estado ?? ""),
      mensaje: String(notif.mensaje ?? "Actualización de pedido"),
      fecha: notif.fecha != null ? String(notif.fecha) : undefined,
      type: "info",
    });
  } catch (e) {
    // eslint-disable-next-line no-console -- diagnóstico en runtime
    console.error("[Nova Admin] notificacionPedido:", e);
  }
});

app.use(router);
app.component("VueApexCharts", VueApexCharts);
app.use(VueQueryPlugin);
app.use(Toast, options);
app.component("v-select", vSelect);
app.mount("#app");
